import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import CTAWrapper from '../CTAWrapper'
import Avatar from 'srcReact/components/common2/Avatar'
import Modal from 'srcReact/components/common2/Modal'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import MobileModal from 'srcReact/components/common2/MobileModal'
import { useTranslation } from 'react-i18next'

function CTAMemberActivities(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    common: { isNative, isMobile, isDesktop },
    commonNewsfeed: { membersWithActivities }
  } = useSelector((state) => state)

  const [cardCount, setCardCount] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    selectedModalUser: {}
  })
  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  useEffect(() => {
    if (isMobile || isNative) {
      setCardCount(3)
    } else {
      setCardCount(5)
    }
  }, [isNative, isMobile, isDesktop])

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const showCards = (isModal) => {
    return (
      <div className={`${styles.members} ${isModal && styles.membersInModal}`}>
        {membersWithActivities.map((member, index) => {
          const type = member.highlight_type
          const emoji =
            type === 'birthday' ? '&#129395;' : type === 'match' ? '&#127881;' : type === 'new' ? '&#128075;' : ''
          const text =
            type === 'birthday'
              ? t('global.birthday')
              : type === 'match'
              ? t('global.match')
              : type === 'new'
              ? t('global.new')
              : ''
          const badgeColor = type === 'birthday' || type === 'match' ? 'purple' : 'green'
          return index < cardCount || isModal ? (
            <div className={styles.card}>
              <Avatar
                userId={member.id}
                firstname={member.firstname}
                lastname={(isMobile || isNative) && !isModal ? '' : member.lastname}
                profilePicture={member.profile_picture_url}
                key={'member_' + member.id}
                containerCSS={styles.avatarContainer}
                userNameCSS={styles.userName}
                customImageCSS={styles.img}
                showUserName={true}
                mimeType={member.mime_type}
                originalTag={member.original_tag}
                isOriginal={member.is_original}
                onClickAction={() => showUserLightModal(member)}
                renderBadge={() => (
                  <div className={styles.avatarBadge}>
                    <span className={styles.emoji} dangerouslySetInnerHTML={{ __html: emoji }} />
                    <span className={styles.text}> {text}</span>
                    <div className={`${styles.wave} ${styles[badgeColor]}`}></div>
                  </div>
                )}
              />
            </div>
          ) : null
        })}
        {!isModal && membersWithActivities.length > cardCount && (
          <button type='button' className={styles.showMore} onClick={openModal}>{`+${
            membersWithActivities.length - cardCount
          }`}</button>
        )}
      </div>
    )
  }

  return membersWithActivities?.length > 0 ? (
    <CTAWrapper className={styles.ctaWrapper}>
      {showCards()}
      {isModalOpen ? (
        <Modal className='memberActivity' isOpen={isModalOpen} handleClose={closeModal}>
          {showCards(true)}
        </Modal>
      ) : null}
    </CTAWrapper>
  ) : null
}

export default CTAMemberActivities
